
import {
  createAction, createFeatureSelector, createReducer, createSelector, props
} from '@ngrx/store';

import { produceOn } from 'app/_state/produce-on';
import { getSafe } from 'helpers';

// STATE
export const StateName = 'ActivityEventItemExpansionState';

export interface ActivityEventItemExpansionState {
  [itemId: string]: {
    expanded: boolean;
  };
}

export const initialState: ActivityEventItemExpansionState = {
};

// SELECTORS
export const getActivityEventExpansionState = createFeatureSelector<ActivityEventItemExpansionState>(StateName);


export const activityEventExpantionStateSelector = (properties: { itemId: string }) => createSelector(getActivityEventExpansionState,
  (state) => getSafe(() => state[properties.itemId].expanded, false)
);

// ACTIONS

/**
 * Expand or Collapse Activity Filter Container
 */
export const setActivityItemExpansionState = createAction(
  '[Activity Event Item Actions] setActivityItemExpantionState',
  props<{ itemId: string; expanded: boolean }>()
);

// REDUCERS
const _activityEventExpansionStateReducers = createReducer(initialState,
  produceOn(setActivityItemExpansionState, (state, payload) => {
    state[payload.itemId] = {expanded: payload.expanded };
  }),
);

export function activityEventExpansionSateReducers(state, action) {
  return _activityEventExpansionStateReducers(state, action);
}
